// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.usfw-notice {
  display: flex;
  align-items: stretch;
  background-color: #414141;
  margin-bottom: 30px;
}
.usfw-notice .notice-tick {
  background-color: #4AB866;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 48px;
  width: 48px;
}
.usfw-notice .notice-tick img {
  display: inline-block;
  vertical-align: top;
}
.usfw-notice .notice-content {
  flex: 1;
  color: #FFFFFF;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0%;
  padding: 16px;
}
.usfw-notice .notice-close {
  flex: 0 0 40px;
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.usfw-notice .notice-close img {
  display: inline-block;
  vertical-align: top;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/layouts/Notice/Notice.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,oBAAA;EACA,yBAAA;EACA,mBAAA;AACJ;AAAI;EACI,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;AAER;AADQ;EACI,qBAAA;EACA,mBAAA;AAGZ;AAAI;EACI,OAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;AAER;AAAI;EACI,cAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAER;AADQ;EACI,qBAAA;EACA,mBAAA;EACA,eAAA;AAGZ","sourcesContent":[".usfw-notice {\n    display: flex;\n    align-items: stretch;\n    background-color: #414141;\n    margin-bottom: 30px;\n    .notice-tick {\n        background-color: #4AB866;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        flex: 0 0 48px;\n        width: 48px;\n        img {\n            display: inline-block;\n            vertical-align: top;\n        }\n    }\n    .notice-content {\n        flex: 1;\n        color: #FFFFFF;\n        font-weight: 400;\n        font-size: 14px;\n        line-height: 22px;\n        letter-spacing: 0%;\n        padding: 16px;\n    }\n    .notice-close {\n        flex: 0 0 40px;\n        width: 40px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        img {            \n            display: inline-block;\n            vertical-align: top;\n            cursor: pointer;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
